import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from '../http.service';
import { ServiceBase } from '../servicebase';
import { AccessClaimModel } from 'services/models/corporate/accessClaim.model';
import { Observable } from 'rxjs';
import { Response } from 'services/models/response';
import { RolePermissionModel } from 'services/models/corporate/rolePermission.model';
import { map } from 'rxjs/operators';
import { AvailableModuleModel } from 'services/models/corporate/availableModule.model';
import { guidEmpty } from 'utils/helps';

@Injectable()
export class RoleService extends ServiceBase<AccessClaimModel> {
  constructor(http: HttpService) {
    super('role', http, environment.apiUrl);
  }

  createEntity(input: any): AccessClaimModel {
    return AccessClaimModel.create(input);
  }

  getActionsByRole(roleId: string): Observable<Response<RolePermissionModel[]>> {
    return this.http.get(`${this.endpoint}/${roleId}/actions-by-role`, null, null, null, true).pipe(
      map(res => {
        const response = new Response<RolePermissionModel[]>();
        response.data = res.body.map(pp => RolePermissionModel.create(pp));
        response.count = res.headers.get('x-count');
        return response;
      })
    );
  }

  getAvailableModules(): Observable<Response<AvailableModuleModel[]>> {
    return this.http.get(`${this.endpoint}/available-modules-actions`).pipe(
      map(res => {
        const response = new Response<AvailableModuleModel[]>();
        response.data = res.body.map(pp => AvailableModuleModel.create(pp));
        response.count = res.headers.get('x-count');
        return response;
      })
    );
  }

  postChangeRolePermission(payload: RolePermissionModel): Observable<any> {
    return new Observable<any>(observer => {
      this.http
        .post(`${this.endpoint}/change-role-permission`, payload, null, null, true)
        .subscribe(
          res => {
            observer.next(res);
            observer.complete();
          },
          err => observer.error(err)
        );
    });
  }

  public createOrUpdate(object: AccessClaimModel): Observable<any> {
    if (object.id && object.id !== '' && object.id !== guidEmpty) {
      return this.http.put(this.endpoint, object, true);
    } else {
      return this.http.post(this.endpoint, object, null, null, true);
    }
  }
}
